<template>
  <div class="login-body">
    <div class="login-container">
      
      <div class="title"><img src="../static/image/logo.png" class="company_logo" /><p>比创达EMC系统注册</p></div>
      <el-form :model="registerForm" :rules="rules2" ref="registerForm" label-position="left" label-width="0px"
              class="demo-ruleForm login-form">
        
        <div class="form-scroll-container">
          <el-form-item prop="email">
            <el-input type="text" v-model="registerForm.email" placeholder="账号(电子邮箱)"></el-input>
          </el-form-item>
          <el-form-item prop="mobile">
            <el-input type="text" v-model="registerForm.mobile" placeholder="手机号码"></el-input>
          </el-form-item>
          <el-form-item prop="realname">
              <el-input v-model="registerForm.realname" placeholder="请输入姓氏"></el-input>
          </el-form-item>
          <el-form-item prop="companyName">
            <el-input v-model="registerForm.companyName" placeholder="请输入公司名"></el-input>
          </el-form-item>
          <el-form-item prop="product">
            <el-input v-model="registerForm.product" placeholder="请输入主营产品"></el-input>
          </el-form-item>
          <el-form-item prop="position">
            <el-input v-model="registerForm.position" placeholder="请输入职位"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="registerForm.password" placeholder="设置密码"></el-input>
          </el-form-item>
          <el-form-item prop="rePassword">
            <el-input type="password" v-model="registerForm.rePassword" placeholder="确认密码"></el-input>
          </el-form-item>
        </div>
        
        
      </el-form>
      <div class="form-scroll-footer">
        <el-button type="primary" @click.native.prevent="handleSubmit2" :loading="logining" class="register-btn">注册</el-button>
        <div class="footer-links">
          <el-button type="text" @click.native.prevent="handleToLogin">去登录</el-button>
          <el-button type="text" @click.native.prevent="handleToIndex">去首页</el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {requestLogin} from '../api/api';
import NProgress from 'nprogress';
import {onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router/composables.mjs';
import {Message} from 'element-ui';

export default {
  data() {
    return {
      logining: false,
      registerForm: {
        email: '',
        mobile: '',
        password: '',
        rePassword: '',
      },
      rules2: {
        email: [
          {required: true, type: 'email', message: '请输入正确的Email地址', trigger: 'blur'},
          //{ validator: validaePass }
        ],
        mobile: [
          {
            required: true,
            type: 'string',
            message: '请输入正确的手机号码',
            trigger: 'blur',
            pattern: /^1[3456789]\d{9}$/,
          },
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 20, message: '密码长度应为6到20个字符', trigger: 'blur'},
        ],
        rePassword: [
          {required: true, message: '请输入确认密码', trigger: 'blur'},
          {min: 6, max: 20, message: '密码长度应为6到20个字符', trigger: 'blur'},
        ],
        companyName: [{required: true, message: '公司名不能为空', trigger: 'blur'}],
        product: [{required: true, message: '主营产品不能为空', trigger: 'blur'}],
        position: [{required: true, message: '职位不能为空', trigger: 'blur'}],
        realname: [{required: true, message: '姓氏不能为空', trigger: 'blur'}],
      },
      checked: true,
    };
  },
  methods: {
    handleReset2() {
      this.$refs.registerForm.resetFields();
    },
    handleSsoOk() {
      this.$router.push({path: '/staHome'});
    },
    handleToLogin() {
      this.$router.push({path: '/login'});
    },
    handleToIndex() {
      this.$router.push({path: '/member/index'});
    },
    handleSubmit2(ev) {
      var _this = this;
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          //_this.$router.replace('/table');
          this.logining = true;
          // NProgress.start();
          if (this.registerForm.password !== this.registerForm.rePassword) {
            Message.info('确认密码与设置密码不一致，请检查！');
            this.logining = false;
            return;
          }
          if (this.registerForm.realname.length === 1) {
            this.registerForm.realname = this.registerForm.realname + '工'
          }

          this.$api.post('/emc-member-auth/reg', this.registerForm).then(res => {
            this.logining = false;
            let data = res.data;
            if (data.code == 200) {
                this.$confirm('申请已提交成功，账号待审核，请联系相关业务员处理。', '提示', {}).then(() => {
                    this.$router.push({path: '/login'});
                })
            } else {
                Message.info(res.data.message);
            }
          });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};

</script>
<style lang="scss" scoped>
  .login-body {
    width: 100%;
    height: 100%;
    background-image: url("../static/image/login-image.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .login-container {
      width: 40%;
      height: 100%;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      display: flex;
      flex-direction: column;
      background-color: #fff;
      border-radius: 12px;
  }

  .title {
    text-align: center;
    color: #505458;
    background-color: #fff;
    margin: 10px 0px;

    p {
      font-size: 20px;
      margin: 1px 0px;
    }
  }

  .company_logo {
      height: 30px;
      width: 80px;
      margin-right: 10px;
  }

  .form-scroll-container {
    max-height: 100%;
    overflow: auto;
  }

  .form-scroll-container::-webkit-scrollbar {
    /* display: none; */
  }

  .login-form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 66%;
    padding: 17px 30px;
    background: #fff;
    border-radius: 12px;
  }

  .el-button {
    width: 100%;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .form-scroll-footer {
    height: 12%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .register-btn {
    width: 85%;
    margin-bottom: 10px;
  }

  .footer-links {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .footer-links .el-button {
    float: right;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Register.vue